<!--
 * @Author: your name
 * @Date: 2021-09-11 10:03:19
 * @LastEditTime: 2021-09-11 10:46:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue-hiprint-examplef:\学习\自学\前端开发\流程管控系统\后端管理系统\vueproject\src\views\produceDataManage\pop\planPop.vue
-->
<template>
  <el-dialog :title="title" visible="true">
    <el-form
      label-width="80px"
      :model="editForm"
      :rules="rules"
      ref="editForm"
    >
     <el-form-item label="名称" prop="name">
        <el-input
          size="small"
          v-model="editForm.name"
          auto-complete="off"
          placeholder="请输入名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="型号" prop="model_type">
        <el-input
          size="small"
          v-model="editForm.model_type"
          auto-complete="off"
          placeholder="请输入型号"
        ></el-input>
      </el-form-item>
      <el-form-item label="生产数量" prop="quantity">
        <el-input
          size="small"
          v-model="editForm.quantity"
          auto-complete="off"
          placeholder="请输入生产数量"
        ></el-input>
      </el-form-item>
      <el-form-item label="生产日期" prop="date_time">
        <el-date-picker v-model="editForm.date_time" type="date" placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
    </el-form>
     <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm">保存</el-button>
      </div>
  </el-dialog>
</template>

<script>
import formatDate from "../../../utils/formatDate"
export default {
  props: ["rowData"],
  data() {
    return {
      editForm: {date_time:new Date()},
      title:"修改计划",
      rules:{
        name:{required: true, message: '请输入名称', trigger: 'blur' },
        quantity:{required: true, message: '请输入数量', trigger: 'blur' },
        model_type:{required: true, message: '请输入型号', trigger: 'blur' },
        quantity:{required: true, message: '请输入数量', trigger: 'blur' },
        date_time:{required: true, message: '请选择日期', trigger: 'blur' }
      }
    };
  },
  created(){
      if(this.rowData.quantity){
          this.title="修改计划"
        this.editForm = {...this.rowData};
      }else{
        this.editForm={}
        this.title="增加计划"
      }
  },
  methods:{
      closeDialog(){
          this.$emit("close")
      },
      submitForm(){
         this.$refs.editForm.validate((res)=>{
        if(res){
           this.editForm['date_time']=formatDate(this.editForm['date_time'],"YYYY-MM-DD hh:mm:ss")
           this.$emit("save", this.editForm);
        }
      })
      }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/produceDataManage/pop/planPop.vue